import React, { FC, ReactElement } from 'react'
import Checkbox, { Props } from '../../../../React/Common/Components/Checkbox/Checkbox'
import Icon, { IconName } from '../../../../React/Common/Components/Icon'

export const RouterCheckbox: FC<Props> = (props: Props): ReactElement => (
    <Checkbox
        {...props}
        className={`${props.className} router-checkbox`}
        checkedIcon={
            <span className='rc-checkbox-checked'>
                <Icon iconName={IconName.CHECK} />
            </span>
        }
        icon={<span className='rc-checkbox-empty'></span>}
    />
)
